// GENERE par pnpm ouvertures:generer. Ne pas modifier a la main.
export const PORTEES_MODELE = {
  "conversations": {
    "canal": "org-wide",
    "direct": "org-wide"
  },
  "messages": {
    "conversation": "org-wide"
  },
  "contacts": {
    "person": "org-wide",
    "organization": "org-wide"
  },
  "contents": {
    "croquis": "org-wide",
    "demo-town": "org-wide"
  },
  "projects": {
    "projet": "org-wide"
  },
  "tasks": {
    "tache": "org-wide"
  },
  "todos": {
    "tache": "org-wide"
  },
  "timesheets": {
    "journal": "org-wide"
  }
} as const;
export const PORTEES_PAR_APP = {
  "canaux": {
    "conversations": {
      "canal": "org-wide",
      "direct": "org-wide"
    },
    "messages": {
      "conversation": "org-wide"
    }
  },
  "cockpit": {},
  "contact": {
    "contacts": {
      "person": "org-wide",
      "organization": "org-wide"
    }
  },
  "croquis": {
    "contents": {
      "croquis": "org-wide"
    }
  },
  "demo-town": {
    "contacts": {
      "organization": "org-wide",
      "person": "org-wide"
    },
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contents": {
      "demo-town": "org-wide"
    }
  },
  "flux": {},
  "projets": {
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contacts": {
      "organization": "org-wide"
    }
  },
  "smart-notes": {},
  "taches": {
    "todos": {
      "tache": "org-wide"
    }
  },
  "timesheet": {
    "timesheets": {
      "journal": "org-wide"
    },
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contacts": {
      "organization": "org-wide"
    }
  }
} as const;
